import { render, staticRenderFns } from "./ExternalInquiry.vue?vue&type=template&id=54b1b483&scoped=true"
import script from "./ExternalInquiry.vue?vue&type=script&lang=js"
export * from "./ExternalInquiry.vue?vue&type=script&lang=js"
import style0 from "./ExternalInquiry.vue?vue&type=style&index=0&id=54b1b483&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b1b483",
  null
  
)

export default component.exports